/*=========================================================================================
	File Name: moduleAuth.js
	Description: Auth Module
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleStockTrackingState.js'
import mutations from './moduleStockTrackingMutations.js'
import actions from './moduleStockTrackingActions.js'
import getters from './moduleStockTrackingGetters.js'

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}
